import React from "react";
import clsx from "clsx";

type MenuItemProps = {} & React.HTMLAttributes<HTMLDivElement>;

export default function MenuItem(props: MenuItemProps) {
    const { children, className, ...rest } = props;
    return (
        <div
            className={clsx(
                "text-slate-600 text-[13px] flex items-center gap-2 px-1 capitalize hover:bg-slate-100 w-full",
                className
            )}
            {...rest}
        >
            {children}
        </div>
    );
}
